import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from './indication-actions';
import {exhaustMap, map, mergeMap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {IndicationRestService} from '@core/modules/rest/indication/indication-rest.service';
import {IndicationBasicModel} from '@core/modules/rest/indication/response/indication-basic.model';
import {IndicationBasicStatusCodeModel} from '@core/modules/rest/indication/response/indication-basic-status-code.model';

@Injectable()
export class IndicationEffects {

    constructor(private actions$: Actions, private indicationRestService: IndicationRestService) {
    }

    getAllIndications$ = createEffect(() => {
            return this.actions$
                .pipe(
                    ofType(fromActions.GetIndications),
                    exhaustMap((action: ReturnType<typeof fromActions.GetIndications>) => {
                        return this.indicationRestService.getOrganizationIndications(action.language)
                            .pipe(
                                map((response: IndicationBasicModel[]) => fromActions.GetIndicationsSuccess({
                                    indications: response
                                }))
                            );
                    })
                );
        }
    );

    getIndication$ = createEffect(() => {
            return this.actions$
                .pipe(
                    ofType(fromActions.GetIndication),
                    exhaustMap((action: ReturnType<typeof fromActions.GetIndication>) => {
                        return this.indicationRestService.getIndication(action.id, action.language)
                            .pipe(
                                map((response: IndicationBasicModel) => fromActions.GetIndicationSuccess({
                                    indication: response
                                }))
                            );
                    })
                );
        }
    );

    cloneIndication$ = createEffect(() => this.actions$
        .pipe(
            ofType(fromActions.CloneIndication),
            exhaustMap((action: ReturnType<typeof fromActions.CloneIndication>) => {
                return this.indicationRestService.cloneIndication(action.indicationId, action.language)
                    .pipe(
                        map((indication: IndicationBasicModel) => {
                            action.executed();
                            return fromActions.CloneIndicationSuccess({indication});
                        })
                    );
            })
        )
    );

    saveIndication$ = createEffect(() => this.actions$
        .pipe(
            ofType(fromActions.SaveIndication),
            exhaustMap((action: ReturnType<typeof fromActions.SaveIndication>) => {
                return this.indicationRestService.saveIndication(action.request, action.language)
                    .pipe(
                        mergeMap((response: IndicationBasicStatusCodeModel) => {
                            action.executed(response);
                            return response.created ? [fromActions.SaveIndicationSuccess({
                                indication: response.indication
                            })] : [];
                        })
                    );
            })
        ));
}
